module.exports = __webpack_public_path__ + "static/media/microfibra.a6cbf800.png";